import { accountRegistrationStatuses, contractStatus, contractType } from '../../../../common/enums';

export const investorInfoObligationsSignableStatuses = [
  accountRegistrationStatuses.DOCUMENTS_ACCEPTED,
  accountRegistrationStatuses.ACCOUNT_ACTIVE,
  accountRegistrationStatuses.NEW_GENERAL_CONTRACT,
];

export const isConfirmedInvestorInfoObligationsContract = contract =>
  contract &&
  contract.type === contractType.INFORMATION_OBLIGATIONS_INVESTOR &&
  contract.status === contractStatus.CONFIRMED;

export const isOpenInvestorInfoObligationsContract = contract =>
  contract &&
  contract.type === contractType.INFORMATION_OBLIGATIONS_INVESTOR &&
  contract.status !== contractStatus.CONFIRMED;

export const getInvestorInfoObligationsContract = ({
  unsignedContracts = [],
  pendingContracts = [],
  accountContracts = [],
}) => {
  if (accountContracts.some(isConfirmedInvestorInfoObligationsContract)) {
    return null;
  }

  return [
    ...unsignedContracts,
    ...pendingContracts,
  ].find(isOpenInvestorInfoObligationsContract) || null;
};

export const canShowInvestorInfoObligations = (registrationStatus, investorInfoObligationsContract) =>
  Boolean(investorInfoObligationsContract) &&
  investorInfoObligationsSignableStatuses.includes(registrationStatus);



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/investorInfoObligationsVisibility.js